import React from 'react'
import Reflux from 'reflux'
import { Row, Col } from 'reactstrap'

import CurrentRecipeStore from '~/stores/currentRecipe.js'


export default class RecipeDetailsSource extends Reflux.Component {
	constructor(props) {
		super(props)

		this.store = CurrentRecipeStore
		this.storeKeys = [
			'link',
			'fromWho'
		]
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	render() {
		// console.log('this.state.fromWho >> ', this.state.fromWho);

		return (
			this.state.fromWho !== ''
			&& this.state.fromWho !== null
		)
			? (
				<Row>
					<Col xs={12} style={{ padding: '1em' }}>
						<strong>
							Source:
						</strong>
						{' '}
						{this.state.fromWho}

						{
							this.state.link !== '' &&
							this.state.link !== null &&

							<React.Fragment>
								{' '}
								<a
									target="_blank"
									rel="noopener noreferrer"
									href={this.state.link}
								>
									{this.state.link}
								</a>
							</React.Fragment>
						}
					</Col>
				</Row>
			)
			: null
	}
}



// WEBPACK FOOTER //
// ./src/modules/details/source.jsx